import { connect } from 'react-redux'
import Search from 'components/layout/search/Search'
import { setCurrentSearchPhrase, setCurrentSearchType, submitSearchUpdate } from 'redux/actions'

const mapStateToProps = state => ({
  flavour: state.layout.flavour,
  searchType: state.search.searchType,
  pageId: state.layout.pageId
})

const mapDispatchToProps = dispatch => ({
  submitSearchUpdate: (props) => dispatch(submitSearchUpdate(props)),
  setCurrentSearchType: searchType => dispatch(setCurrentSearchType(searchType)),
  setCurrentSearchPhrase: searchPhrase => dispatch(setCurrentSearchPhrase(searchPhrase))
})

export default connect(mapStateToProps, mapDispatchToProps)(Search)
